import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useContext } from "react";

// ================= CONTEXT =================
import { AuthProvider, AuthContext } from "./context/AuthContext";

// ================= LAYOUT =================
import ClientLayout from "./layout/ClientLayout";
import AdminLayout from "./admin/layout/AdminLayout";

// ================= CLIENT PAGES =================
import "./index.css";


import Home from "./pages/user/Home/Home";
import About from "./pages/user/About/About";
import Blog from "./pages/user/Blog/Blog";
import BlogDetails from "./pages/user/Blog/BlogDetails";
import ProductDetail from "./pages/user/ProductDetail/ProductDetail";
import Cart from "./pages/user/Cart/Cart";
import Checkout from "./pages/user/Checkout/Checkout";
import MedicalConditions from "./pages/user/Checkout/MedicalConditions";
import Payment from "./pages/user/Checkout/Payment";
import BankDetails from "./pages/user/Checkout/BankDetails";
import Invoice from "./pages/user/Checkout/Invoice";
import CryptoSelection from "./pages/user/Checkout/CryptoSelection";
import CryptoPayment from "./pages/user/Checkout/CryptoPayment";
import Success from "./pages/user/Success/Success";
import MyOrders from "./pages/user/MyOrders/MyOrders";
import CategoriesProducts from "./pages/user/Category/CategoriesProducts";
import Delivery from "./pages/user/Delivery";
import Security from "./pages/user/Security";
import Support from "./pages/user/Support";
import Worldwide from "./pages/user/Worldwide";
import AWS from "./pages/user/AWS";
import SSL from "./pages/user/SSL";
import IndianPharmacies from "./pages/user/IndianPharmacies";
import ProtectYourself from "./pages/user/ProtectYourself";
import RegulatedMedicine from "./pages/user/RegulatedMedicine";
import ReturnsExchanges from "./pages/user/ReturnsExchanges";
import SafeShopping from "./pages/user/SafeShopping";
import FAQ from "./pages/user/FAQ";
import Contact from "./pages/user/Contact/Contact";
import RemitlyDetails from "./pages/user/Checkout/RemitlyDetails";
import WesternUnionDetails from "./pages/user/Checkout/WesternUnionDetails";


// ================= ADMIN =================
import "./App.css";

import Dashboard from "./pages/admin/Dashboard/Dashboard";
import AddProduct from "./pages/admin/Products/AddProduct";
import EditProduct from "./pages/admin/Products/EditProduct";
import ViewProduct from "./pages/admin/Products/ViewProduct";
import AddCategory from "./pages/admin/Category/AddCategory";
import ViewCategory from "./pages/admin/Category/ViewCategory";
import EditCategory from "./pages/admin/Category/EditCategory";
import Orders from "./pages/admin/Orders/Orders";
import ViewBlog from "./pages/admin/Blogs/ViewBlog";
import AddBlog from "./pages/admin/Blogs/AddBlog";
import EditBlog from "./pages/admin/Blogs/EditBlog";
import Reviews from "./pages/admin/Reviews/Reviews";
import Customers from "./pages/admin/Customers/Customers";
import AdminContact from "./pages/admin/Contacts/AdminContact";
import ViewSubscribers from "./pages/admin/Newsletter/ViewSubscribers";
import Login from "./pages/admin/AdminLogin/Login";
import ProtectedRoute from "./ProtectedRoute";

// ================= AUTH POPUP =================
import AuthModal from "./components/auth/AuthModal";



// ================= ROUTES =================
function AppContent() {
  return (
    <>
      <BrowserRouter>
        <Routes>

          {/* ================= CLIENT ================= */}
          <Route path="/" element={<ClientLayout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="categories/:slug" element={<CategoriesProducts />} />
            <Route path="blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetails />} />
            <Route path="cart" element={<Cart />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="/checkout/medical" element={<MedicalConditions />}/>
            <Route path="/checkout/payment" element={<Payment />} />
            <Route path="/checkout/bank-details" element={<BankDetails />} />
            <Route path="/checkout/invoice" element={<Invoice />} />
            <Route path="/checkout/crypto-selection" element={<CryptoSelection />} />
            <Route path="/checkout/crypto-payment/:coin" element={<CryptoPayment />} />
            <Route path="/success" element={<Success />}/>
            <Route path="/my-orders" element={<MyOrders />}/>
            <Route path="/delivery" element={<Delivery />} />
            <Route path="/security" element={<Security />} />
            <Route path="/support" element={<Support />} />
            <Route path="/worldwide" element={<Worldwide />} />
            <Route path="/aws-security" element={<AWS />} />
            <Route path="/ssl" element={<SSL />} />
            <Route path="/indian-pharmacies" element={<IndianPharmacies />} />
            <Route path="/protect-yourself" element={<ProtectYourself />} />
            <Route path="/regulated-medicine" element={<RegulatedMedicine />} />
            <Route path="/returns-exchanges" element={<ReturnsExchanges />} />
            <Route path="/safe-shopping" element={<SafeShopping />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/checkout/remitly-details" element={<RemitlyDetails />} />
            <Route path="/checkout/western-union-details" element={<WesternUnionDetails />} />
            
          </Route>

          {/* ================= ADMIN LOGIN ================= */}
          <Route path="/admin/login" element={<Login />} />

          {/* ================= ADMIN PANEL ================= */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />

            <Route path="products/add" element={<AddProduct />} />
            <Route path="products/view" element={<ViewProduct />} />
            <Route path="products/edit/:id" element={<EditProduct />} />
             
            <Route path="categories/add" element={<AddCategory />} />
            <Route path="categories/view" element={<ViewCategory />} />
            <Route path = "categories/edit/:id" element={<EditCategory />}/>
    
            <Route path="blog" element={<ViewBlog />} />
            <Route path="blog/add" element={<AddBlog />} />
            <Route path="blog/edit/:id" element={<EditBlog />} />

            <Route path="orders" element={<Orders />} />
            <Route path="reviews" element={<Reviews />} />
            <Route path="customers" element={<Customers />} />
            <Route path="contact" element={<AdminContact />} />
            <Route path="newsletter" element={<ViewSubscribers />} />
          </Route>

        </Routes>
      </BrowserRouter>

      {/* ================= GLOBAL AUTH MODAL ================= */}
      <GlobalAuth />
    </>
  );
}


// ================= SAFE AUTH WRAPPER =================
function GlobalAuth() {
  const auth = useContext(AuthContext);

  // safety check (IMPORTANT to avoid blank screen)
  if (!auth) return null;

  const { showAuth } = auth;

  return showAuth ? <AuthModal /> : null;
}


// ================= MAIN APP =================
function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;